// const GRADIENTS = [
//   {0: 'rgba(89,60,143,1)', 1: 'rgba(255,0,0,1)'},
//   {0: 'rgba(95,180,156,1)', 1: 'rgba(255,0,0,1)'},
//   {0: 'rgba(255,117,60,1)', 1: 'rgba(255,0,0,1)'},
//   {0: 'rgba(0,81,163,1)', 1: 'rgba(255,0,0,1)'},
//   {0: 'rgba(239,111,108,1)', 1: 'rgba(255,0,0,1)'},
//   {0: 'rgba(254,209,60,1)', 1: 'rgba(255,0,0,1)'}
// ];

// export { GRADIENTS };

const COLORMAP = {
  orange: '#FAA85F', //orange
  blue: '#1D4199', //blue
  pink: '#EF4889', //pink
  teal: '#15938B', //teal
  yellow: '#E8C728', //yellow
  purple: '#8427CC' //purple
};

const COLORS = [
  COLORMAP.orange,
  COLORMAP.blue,
  COLORMAP.pink,
  COLORMAP.teal,
  COLORMAP.yellow,
  COLORMAP.purple
];

// const YELLOW = '#FDD03C';

export { COLORS, COLORMAP };


// WEBPACK FOOTER //
// ./src/styles/index.js